import React, { Component } from "react";
import styled, { css } from "styled-components";

class AsapDrawer extends Component {
  componentDidUpdate() {
    if (this.props.overlay) {
      document.body.classList.toggle("noscroll", this.props.open);
    }
  }
  render() {
    const {
      open, overlay, onRequestClose, width, right, drawerContainerStyle, style,
    } = this.props;
    return (
      <AsapDrawerView style={style} ariaHidden={!open}>
        {overlay !== false && open && <Overlay onClick={() => onRequestClose()} />}
        <Drawer style={drawerContainerStyle} right={right} open={open} width={width}>
          <div style={{ height: "100%", minWidth: `${width || "255"}px` }}>
            {this.props.children}
          </div>
        </Drawer>
      </AsapDrawerView>
    );
  }
}

export default AsapDrawer;

const AsapDrawerView = styled.div`
  z-index: 10000;
`;

const Drawer = styled.div`
  height: 100%;
  width: ${({ open, width }) => (open ? width || "255" : "0")}px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.08);
  position: fixed;
  top: 0;
  ${({ right }) =>
    (right
      ? css`
          right: 0;
        `
      : css`
          left: 0;
        `)};
  z-index: 9999;
  background-color: ${({ color }) => color || "white"};
  overflow-x: hidden;
  transition: 0.3s;
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9998;
  background-color: rgba(0, 0, 0, 0.5);
`;



// WEBPACK FOOTER //
// ./src/components/AsapDrawer.js